/* global Autodesk, THREE */ // eslint-disable-line
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { getForgeToken } from "../../helpers/axios/Get";
import { VIEWER_API } from "../../helpers/constants/Constants";

let viewer;
const PdfPanel = () => {
  const pdfState = useSelector((state) => state.pdfStateReducer.pdfState);
  const pdf = useSelector((state) => state.pdfStateReducer.pdf);

  const loadPdf = (url) => {
    let options = {
      env: "AutodeskProduction",
      api: VIEWER_API,
      getAccessToken: getForgeToken,
      refreshToken: getForgeToken,
      PushPinExtensionHandle: null,
    };

    Autodesk.Viewing.Initializer(options, async function () {
      const viewer = new Autodesk.Viewing.GuiViewer3D(
        document.getElementById(
          "dXJuOmFkc2sud2lwZW1lYTpmcy5maWxlOnZmLm8zbDRNaVNOVEVTWnc3Z2FlRTNxSGc_dmVyc2lvbj0x-viewer"
        )
      );
      viewer.start();
      viewer.setTheme("light-theme");
      viewer.loadExtension("Autodesk.DocumentBrowser");
      viewer.loadExtension("Autodesk.PDF").then(() => {
        viewer.loadModel(url);
      });
    });
  };

  return (
    <div>
      <h2>PDF Panel</h2>
      <model-viewer
        alt="Neil Armstrong's Spacesuit from the Smithsonian Digitization Programs Office and National Air and Space Museum"
        src="shared-assets/models/NeilArmstrong.glb"
        ar
        environment-image="shared-assets/environments/moon_1k.hdr"
        poster="shared-assets/models/NeilArmstrong.webp"
        shadow-intensity="1"
        camera-controls
        touch-action="pan-y"></model-viewer>
      <ul>
        {pdf?.pages.map((pdf, i) => {
          return (
            <li onClick={() => loadPdf(pdf.url())}>
              <span>{pdf.name}</span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default PdfPanel;